import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader,CardFooter, Row, Col } from "reactstrap";
import CardItem from "./card-item";
import CardView from "./card-view";
import { NavLink } from "react-router-dom";
import Ubigeo from "../../commons/ubigeo.module";
import "./seccion-datos-documentos.scss";
class SeccionDatosDocumentos extends React.Component {
  static propTypes = {
    ubigeo: PropTypes.string,
    marco: PropTypes.string,
    publicaciones: PropTypes.array,
    normas: PropTypes.array
  };
  render() {
    let nombreRegion = "00";
    let url = "";
    if (this.props.ubigeo) {
      nombreRegion = this.props.ubigeo || '';
    }
    if (this.props.marco) {
      url = "&tematica=" + this.props.marco;
    }
    if (this.props.ubigeo) {
      url += "&region=" + nombreRegion;
    }
    return (
      <Row>
        <Col xs={12} sm={12} md={12} xl={12}>
          <Card className="card-border-line mb-3">
            <CardHeader className="card-card-header__padding">
              <Row className="no-gutters">
                <Col xs={12} sm={7} md={9} xl={10}>
                  <div className="text-secondary">
                    <span><h5>Normas ambientales</h5></span>
                  </div>
                </Col>
                <Col xs={12} sm={5} md={3} xl={2} className="mt-3 text-right">
                  <NavLink
                    key={this.props.marco}
                    to={`./normas?${url}`}>
                      <i className="fas fa-plus" aria-hidden="true" />
                      <span className="text-primary ml-1">Ver todos {" "}</span>
                  </NavLink>
                </Col>
              </Row>
            </CardHeader>
            <CardItem items={this.props.normas} />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={12} xl={12}>
          <Card className="card-border-line mb-3">
            <CardHeader className="card-card-header__padding">
              <Row className="no-gutters">
                <Col xs={12} sm={7} md={9} xl={10}>
                  <div className="text-primary">
                  <span><h5>Publicaciones ambientales</h5></span>
                  </div>
                </Col>
                <Col xs={12} sm={5} md={3} xl={2} className="mt-2 text-right">
                  <NavLink
                    key={this.props.marco}
                    to={`./publicaciones?${url}`}
                  >
                    <i className="fas fa-plus" aria-hidden="true" />
                    <span className="text-primary ml-1">Ver todos{" "}</span>
                  </NavLink>
                </Col>
              </Row>
            </CardHeader>
            <CardView items={this.props.publicaciones} />
          </Card>
        </Col>
      </Row>
    );
  }
}
export default SeccionDatosDocumentos;
